import { ExportFile } from '../types/export/export';
import {
  CreateProductTransactionExportConfigurationInput,
  DeleteProductTransactionExportConfigurationInput,
  ProductTransactionExportConfiguration,
  UpdateProductTransactionExportConfigurationInput,
} from '../types/product_transaction_export_configuration';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const EXPORT = '/api/product_transaction/export';
const CONFIGURATIONS = '/api/product_transaction/export/list';
const CREATE_CONFIGURATION = '/api/product_transaction/export/create';
const UPDATE_CONFIGURATION = '/api/product_transaction/export/update';
const DELETE_CONFIGURATION = '/api/product_transaction/export/delete';

export namespace ProductTransactionExportConfigurationRequest {
  export interface ProductTransactionExportPayload {
    configId?: string;
    timezone?: string;
    locale?: string;
  }

  export const download = async (payload: ProductTransactionExportPayload): Promise<ExportFile> => {
    return (await http.post(EXPORT, payload)).data;
  };

  export const list = async (payload: {
    page: number;
  }): Promise<PaginatedResponse<ProductTransactionExportConfiguration>> => {
    return (await http.post(CONFIGURATIONS, payload)).data;
  };

  export const create = async (payload: {
    data: CreateProductTransactionExportConfigurationInput[];
  }): Promise<ProductTransactionExportConfiguration[]> => {
    return (await http.post(CREATE_CONFIGURATION, payload)).data;
  };

  export const update = async (payload: {
    data: UpdateProductTransactionExportConfigurationInput[];
  }): Promise<ProductTransactionExportConfiguration[]> => {
    return (await http.post(UPDATE_CONFIGURATION, payload)).data;
  };

  export const remove = async (payload: {
    data: DeleteProductTransactionExportConfigurationInput[];
  }): Promise<ProductTransactionExportConfiguration[]> => {
    return (await http.post(DELETE_CONFIGURATION, payload)).data;
  };
}
